const identifiers = ['#', '!'];
const regexSingleTag = (tag) => new RegExp(`[${identifiers.join('|')}]${tag}`);
const regexWordsAndTags = new RegExp(`([${identifiers.join('|')}]?\\w+)`, 'g');
const regexIdentifiers = new RegExp(`[${identifiers.join('|')}]`, 'g');

const types = {
  tag: 'tag',
  word: 'word',
};

const positions = {
  leading: 'leading',
  trailing: 'trailing',
  between: 'between',
};

// checks if the given value is a tag or not
const matchIsTag = (match) => typeof match === 'string' &&
  identifiers.find((identifier) => match.startsWith(identifier));

// determines the tag's position by index and array
const getTagPosition = (index, tags) => {
  const previous = tags[index - 1];
  const next = tags[index + 1];

  // if there is no previous entry or the previous one is also a tag
  if (!previous || matchIsTag(previous)) {
    return positions.leading;
  }

  // if there is no next entry or the next one is also a tag
  if (!next || matchIsTag(next)) {
    return positions.trailing;
  }

  return positions.between;
};

// enriches the given word or tag with additional info on type, symbol and position
const mapWordsAndTags = (wordOrTag, index, wordsAndTags) => {
  const isTag = matchIsTag(wordOrTag);

  return {
    tag: wordOrTag.replace(regexIdentifiers, ''),
    type: isTag ? types.tag : types.word,
    symbol: isTag ? wordOrTag.substr(0, 1) : '',
    position: isTag ? getTagPosition(index, wordsAndTags) : '',
  };
};

const getTagsFromQuery = (query) => {
  const wordsAndTags = [];

  // split given query into single values,
  // only considering words and tags by regexp
  let match = regexWordsAndTags.exec(query);
  while (match !== null) {
    wordsAndTags.push(match[1]);
    match = regexWordsAndTags.exec(query);
  }

  // enrich data with additional info on type, symbol and position,
  // then return only tags by filtering
  return wordsAndTags.map(mapWordsAndTags)
    .filter(({ type }) => type === types.tag);
};

const addTagToQuery = (query, tag) => [
  query,
  ' ',
  identifiers[0],
  tag,
].join('');

const removeTagFromQuery = (query, tag) => query
  .replace(regexSingleTag(tag), '')
  .trim();

module.exports = {
  types,
  positions,
  identifiers,
  regexWordsAndTags,
  regexIdentifiers,
  regexSingleTag,
  addTagToQuery,
  getTagsFromQuery,
  removeTagFromQuery,
};
